export class ReportClauseMaintenanceQueryParameters {
  embed?: any;
  id?: string;
  page?: number;
  pageSize?: number;
  reportClauseTypeId?: string;
  rooftopId?: string;
  search?: string;

  constructor(obj?: ReportClauseMaintenanceQueryParameters) {
    if (obj) Object.assign(this, obj);
  }
}
